import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon } from '../../shared/services/config-app';

@Component({
  selector: 'app-cardpayko',
  templateUrl: './cardpayko.component.html',
  styleUrls: ['./cardpayko.component.scss']
})
export class CardpaykoComponent implements OnInit {

  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;


  constructor(private route: ActivatedRoute, private router: Router,
    private cartService: CartService) {

    this.cartData = new EitCart();


  }

  ngOnInit(): void {
    this.cartData = this.cartService.cart;
  }


  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }

}
